<ng-template #offcanvas let-offcanvas>
  <div
    class="offcanvas-header"
    [class.border-bottom]="showDivider"
    [class.border-gray-300]="showDivider"
    [class.pb-3]="showDivider"
    [class.mb-3]="showDivider"
  >
    @if (offcanvasConfig.collapseButtonBeforeTitle) {
    <button type="button" class="btn btn-icon btn-sm" (click)="dismiss()" matTooltip="Collapse">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>}
    <h4 class="offcanvas-title">{{offcanvasConfig.title}}</h4>
    <button type="button" class="btn-close text-reset ms-auto" (click)="dismiss()"></button>
  </div>
  <div class="offcanvas-body" [ngClass]="{ 'p-0': offcanvasConfig.noPadding }">
    <ng-content></ng-content>
  </div>
</ng-template>